import { gql } from "@apollo/client";

export const SEARCH_PROVIDER_PORTAL_MEMBERS = gql`
  query SearchProviderPortalMembers($input: ProviderPortalMemberSearchInput!) {
    searchProviderPortalMembers(input: $input) {
      companyId
      membMpiNo
      membKeyId
      membId
      firstName
      lastName
      fullName
      gender
      dob
      phone
      email
      healthPlanName
      healthPlanCode
      startDate
    }
  }
`;

export interface ProviderPortalMember {
  companyId: string;
  membMpiNo: string;
  membKeyId?: string | null;
  membId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  gender?: string | null;
  dob?: string | null;
  phone?: string | null;
  email?: string | null;
  healthPlanName?: string | null;
  healthPlanCode?: string | null;
  startDate?: string | null;
}

export interface ProviderPortalMemberSearchInput {
  memberId?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  /** Target IPA (PP companyId) — scopes the search to one IPA's backend. */
  companyId?: string;
}

export interface SearchProviderPortalMembersVars {
  input: ProviderPortalMemberSearchInput;
}

export interface SearchProviderPortalMembersResponse {
  searchProviderPortalMembers: ProviderPortalMember[];
}
